/* BELLER 22.10.2026: prawa kolumna karty produktu jest od 953 px przyklejona do gory okna (base.css, .product-form-frame).
   Gdy jest wyzsza niz okno, jej dol (Dostawa, FAQ) byl nieosiagalny, dopoki zdjecia z lewej sie nie skonczyly.
   Teraz kolumna przewija sie razem ze strona, az pokaze sie jej dol (w dol) albo gora (w gore), i dopiero wtedy sie przykleja.
   Gdy kolumna miesci sie w oknie, nic sie nie zmienia. */
(function () {
  var f = document.querySelector('.main-product .product-form-frame');
  if (!f) return;
  var mq = window.matchMedia('(min-width: 953px)');
  var ODSTEP = 24, gora = 0, dol = 0, t = null, aktywny = false, ostatni = window.scrollY;
  function zmierz() {
    f.style.top = '';
    aktywny = false;
    if (!mq.matches) return;
    gora = parseFloat(window.getComputedStyle(f).top) || 0;
    var h = f.offsetHeight;
    if (h + gora + ODSTEP <= window.innerHeight) return;
    dol = window.innerHeight - h - ODSTEP;
    aktywny = true;
    if (t === null) t = gora;
    t = Math.min(gora, Math.max(dol, t));
    f.style.top = t + 'px';
  }
  function przewin() {
    var y = window.scrollY, d = y - ostatni;
    ostatni = y;
    if (!aktywny || !d) return;
    var n = Math.min(gora, Math.max(dol, t - d));
    if (n !== t) { t = n; f.style.top = t + 'px'; }
  }
  window.addEventListener('scroll', przewin, { passive: true });
  window.addEventListener('resize', zmierz);
  if (window.ResizeObserver) new ResizeObserver(zmierz).observe(f);
  zmierz();
})();
